<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Department Name</label>
                  <input type="text"  v-model="form.deptname"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Department Head</label>
                  <input type="text"  v-model="form.depthead"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Phone</label>
                  <input type="text"  v-model.number="form.phone"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <input type="text"  v-model="form.email"/>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Update</a>
                <router-link to="customerlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
axios.defaults.baseURL ='https://pzyyoroy465ujo2oimjmeqfsum0snnrs.lambda-url.ap-south-1.on.aws';
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  data() {
    return {
      form: {
        deptname: '',
        depthead: '',
        phone: '',
        email: '',
      },
      filter: true,
      id: this.$route.query.id,
      title: "Edit Department",
      title1: "Edit",
    };
  },
  methods: {
    postData() {
      if (!this.form.deptname) {
        Swal.fire("Please enter the Department name");
        return;
      }
      axios
      .put('/v1/departments/' + this.id, this.form)
      .then(response => {
        Swal.fire("Department updated successfully");
        this.$router.push({ path: '/customerlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getCategoryById(id) {
      axios
      .get('/v1/departments/'+id)
      .then(response => {
        this.form = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getCategoryById(this.id);
  },
  name: "editcustomer",
};
</script>

